/**
 * Created by neo on 16.10.21.
 */
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { HealthDataPointAnalyticsResult, createHealthDataPointAnalyticsResult } from './HealthDataPointAnalyticsResult';

export type AggregateType = 'sum' | 'average' | 'min' | 'max';

export type AggregateWindow = 'hour' | 'day' | 'week' | 'month' | 'year' | 'none';

export type HealthDataPointAnalyticsQueryRequest = Record<string, any> & {
  type?: string[] | string;
  startDateTime?: Date;
  endDateTime?: Date;
  sourceId?: string[];
  sourceType?: string;
  aggregate?: AggregateType;
  window?: AggregateWindow;
};

/**
 * To get a 'series' of data use the window function and set it accordingly
 */
export const HealthDataPointAnalyticsApi = {
  find(request?: HealthDataPointAnalyticsQueryRequest): Promise<HealthDataPointAnalyticsResult[]> {
    const finalRequest = Object.assign({ window: 'day' }, request ?? {});
    return HttpBackend.get(`/athlete/health-data/analytics`, finalRequest).then((result) =>
      (result ?? []).map((r: any) => createHealthDataPointAnalyticsResult(r)),
    );
  },

  summary(request?: HealthDataPointAnalyticsQueryRequest): Promise<Record<string, number>> {
    const finalRequest = Object.assign({}, request ?? {});
    if (request) {
      delete finalRequest.window;
    }
    return HttpBackend.get(`/athlete/health-data/analytics/average/day`, finalRequest).then((result: any[]) => {
      return (result ?? []).reduce(
        (agg, curr) => Object.assign(agg, { [curr.id]: curr.value }),
        {} as Record<string, number>,
      );
    });
  },
};

export const HealthDataPointAnalytics = HealthDataPointAnalyticsApi;
